module.exports = __webpack_public_path__ + "img/software_copyright.036bc609.png";